<template>
  <div
    class="tw-flex tw-min-h-screen tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-p-3 tw-text-center"
  >
    <template v-if="checking">
      <Spinner />
    </template>

    <template v-else>
      <Heading level="h1" level-class="h2">
        {{ t('nate') }}
        <span class="tw-text-red">{{ t('header_navigation.control_room') }}</span>
      </Heading>

      <Text class="tw-max-w-xl tw-text-white/68">{{ t('sign_in.subtitle') }}</Text>

      <Button color="semiTransparentWhite" @click="signIn">{{ t('sign_in.button') }}</Button>
    </template>

    <Logo class="tw-fixed tw-bottom-5 tw-right-5 tw-z-[-1] tw-hidden tw-w-28 lg:tw-block" />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Button, Heading, Logo, Spinner, Text } from '@slideslive/fuse-kit/vue';

import useAuthStore from '@/stores/auth';

defineProps({
  checking: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const authStore = useAuthStore();

function signIn() {
  authStore.signIn();
}
</script>
